
export const removeExtraFormatting = (text) => {
    return text?.replace(/&nbsp;/g, " ");
}

export default removeExtraFormatting;